import { render, staticRenderFns } from "./CommentsTable.vue?vue&type=template&id=6774c379"
import script from "./CommentsTable.vue?vue&type=script&lang=js"
export * from "./CommentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports